export default "https://cdn-shared.mathletics.com/teacher-modules/mx-portal/278/assets/images/question-mark-272e3b5afeaa7f8cfa0a62816c780e55.svg";